import React, { useEffect, useState } from 'react';
import API from '../utils/api';

export default function OfferPopup() {
  const [offer, setOffer]     = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    API.get('/offers/active')
      .then(res => {
        if (res.data.success && res.data.data) {
          const dismissed = sessionStorage.getItem(`offer_dismissed_${res.data.data._id}`);
          if (!dismissed) {
            setOffer(res.data.data);
            setTimeout(() => setVisible(true), 1400);
          }
        }
      })
      .catch(() => {});
  }, []);

  const dismiss = () => {
    setVisible(false);
    if (offer) sessionStorage.setItem(`offer_dismissed_${offer._id}`, '1');
  };

  if (!offer || !visible) return null;

  return (
    <div className="offer-overlay" role="dialog" aria-modal="true" aria-label="Special Offer" onClick={e => { if (e.target === e.currentTarget) dismiss(); }}>
      <div className="offer-popup">
        {/* X close top-right */}
        <button className="offer-popup__x" onClick={dismiss} aria-label="Close">✕</button>

        {/* Large poster image area */}
        <div className="offer-popup__poster">
          {offer.imageUrl
            ? <img src={offer.imageUrl} alt={offer.title} className="offer-popup__poster-img" />
            : (
              <div className="offer-popup__poster-fallback">
                <span className="offer-popup__emoji">{offer.emoji || '🌸'}</span>
                <span className="offer-popup__badge-chip">{offer.badgeText || 'Special Offer'}</span>
              </div>
            )
          }
        </div>

        {/* Text body */}
        <div className="offer-popup__body">
          <h2 className="offer-popup__title">{offer.title}</h2>
          {offer.description && <p className="offer-popup__desc">{offer.description}</p>}
          <div className="offer-popup__actions">
            <a href="/#contact" className="offer-popup__cta" onClick={dismiss}>
              {offer.ctaText || 'Book Now'}
            </a>
            <button className="offer-popup__close-btn" onClick={dismiss}>Maybe Later</button>
          </div>
        </div>
      </div>
    </div>
  );
}
